import { AppState } from 'Features/App/store';
import { DICTIONARIES_SLICE } from '../dictionariesSlice';

export const datasourceStatusesSelectorMonitoring = (state: AppState) => state[DICTIONARIES_SLICE].datasourceStatuses;
export const datasourceStatusSelectorMonitoring = (datasourceId: number) => (state: AppState) => {
    return state[DICTIONARIES_SLICE].datasourceStatuses[datasourceId];
};
export const datasourceStatusEnabledModeSelectorMonitoring = (datasourceId: number) => (state: AppState) => {
    return state[DICTIONARIES_SLICE].datasourceStatuses[datasourceId]?.enableMode;
};
export const datasourceStatusDangerModeSelectorMonitoring = (datasourceId: number) => (state: AppState) => {
    return state[DICTIONARIES_SLICE].datasourceStatuses[datasourceId]?.dangerMode;
};

export const datasourceStatusStormModeSelectorMonitoring = (datasourceId: number) => (state: AppState) => {
    return state[DICTIONARIES_SLICE].datasourceStatuses[datasourceId]?.stormMode;
};
export const datasourceStatusSoftReleaseModeSelectorMonitoring = (datasourceId: number) => (state: AppState) => {
    return state[DICTIONARIES_SLICE].datasourceStatuses[datasourceId]?.softRelease;
};
export const datasourceStatusDataReceivedSelectorMonitoring = (datasourceId: number) => (state: AppState) => {
    return state[DICTIONARIES_SLICE].datasourceStatuses[datasourceId]?.dataReceived;
};
